import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';

/**
 * Only accepts one menu to be expandable (only animals).
 * Needs to be optimized if we want more expandable menu items
 */
export default class DesktopMenu extends Component {
  #menuLeaveHandler: function;
  #animalHoverHandler: function;
  #animalTouchHandler: function;
  #activeIndex: number = 0;
  menu: HTMLElement;
  animalItems: Array<HTMLElement> = [];
  activeClass: string = 'menu__item--active';

  /**
   *
   */
  bind(el: HTMLElement) {
    super.bind(el);
    this.setUp();

    this.#menuLeaveHandler = this.onMenuLeave.bind(this);
    this.menu.addEventListener(EventNames.MOUSE_LEAVE, this.#menuLeaveHandler);

    this.#animalHoverHandler = this.onAnimalHover.bind(this);
    this.#animalTouchHandler = this.onAnimalTouch.bind(this);
    this.animalItems.forEach((item: HTMLElement) => {
      item.addEventListener(EventNames.MOUSE_ENTER, this.#animalHoverHandler);

      const link = item.getElementByRef('animal-link');
      if (!link) return;

      link.addEventListener(EventNames.TOUCH_START, this.#animalTouchHandler, { passive: true });
    });
  }

  /**
   * Set up of properties and validation
   */
  setUp(): void {
    const menu: ?HTMLElement = this.el.querySelector('[data-depth="0"]');
    if (!menu) throw new Error('No desktop menu was found');

    this.menu = menu;
    this.animalItems = Array.from(menu.querySelectorAll('[data-depth="1"] > li'));
  }

  /**
   * Executes when the mouse enter event is triggered on a animal item of the menu
   */
  activateAnimalMenu(target: HTMLLIElement): void {
    this.animalItems[this.#activeIndex].classList.remove(this.activeClass);
    this.#activeIndex = this.animalItems.indexOf(target);
    this.animalItems[this.#activeIndex].classList.add(this.activeClass);
  }

  /**
   * Executes when the user leaves the menu
   */
  onMenuLeave(): void {
    this.animalItems[this.#activeIndex].classList.remove(this.activeClass);
    this.#activeIndex = 0;
    this.animalItems[this.#activeIndex].classList.add(this.activeClass);
  }

  /**
   * Executes when the animal items are hovered
   */
  onAnimalHover(e: Event): void {
    this.activateAnimalMenu(e.target);
  }

  /**
   * disables default event on touch and sets an active class to the touched item
   */
  onAnimalTouch(e: Event):void {
    e.preventDefault();
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    if (!(target instanceof HTMLLIElement)) {
      const listItem: ?HTMLLIElement = target.closest('li');
      if (!listItem) {
        throw Error('There was no animal item found in the menu');
      }

      this.activateAnimalMenu(listItem);
      return;
    }

    this.activateAnimalMenu(target);
  }

  /**
   * Destroy all event listeners
   */
  destroy(): void {
    this.animalItems.forEach((item: HTMLElement) => {
      item.removeEventListener(EventNames.MOUSE_ENTER, this.#animalHoverHandler);
      const link = item.getElementByRef('animal-link');
      if (!link) return;
      link.removeEventListener(EventNames.TOUCH_START, this.#animalTouchHandler);
    });
  }
}
